import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

function Hero() {
  useEffect(() => {
    // Load Trustpilot widget script
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(document.getElementById('trustpilot-widget'), true);
    }
  }, []);

  return (
    <section id="home" className="hero">
      <div className="container hero-container">
        <div className="hero-content">
          <h1 className="hero-title">MeowBox Studios</h1>
          <p className="hero-subtitle">Creating immersive experiences on Roblox</p>
          <p className="hero-description">
            A small team of 2 developers building engaging horror games and 
            experiences for the Roblox platform.
          </p>
          <div className="hero-buttons">
            <Link to="/games" className="hero-btn primary">View Our Games</Link>
            <Link to="/team" className="hero-btn secondary">Meet the Team</Link>
          </div>
          
          {/* TrustBox widget - Review Collector */}
          <div 
            id="trustpilot-widget"
            className="trustpilot-widget" 
            data-locale="en-US" 
            data-template-id="56278e9abfbbba0bdcd568bc" 
            data-businessunit-id="69192dac15651ce0b9481245" 
            data-style-height="52px" 
            data-style-width="100%" 
            data-token="f6a3aca5-296c-44f9-a6b1-7aa2d72f35bc"
            style={{ marginTop: '40px' }}
          >
            <a href="https://www.trustpilot.com/review/meowboxstudios.com" target="_blank" rel="noopener noreferrer">Trustpilot</a>
          </div>
          {/* End TrustBox widget */}
        </div>
      </div>
    </section>
  );
}

export default Hero;
